import { ThirdPartyExternalLink } from '@cmsgov/design-system';
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const HealthcaregovThirdPartyExternalLink = function (props) {
  const {
    learnMoreUrl = 'https://www.healthcare.gov/links-to-other-sites/'
  } = props;
  return /*#__PURE__*/_jsx(ThirdPartyExternalLink, {
    learnMoreUrl: learnMoreUrl,
    ...props
  });
};
export { HealthcaregovThirdPartyExternalLink };